import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var AdminLoginRes;
export const AdminLoginTodo = createAsyncThunk('AdminLogin', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'admin/login',
            data: {
                "mobile": data.user,
                "password": data.password,
                // "deviceType": "master"
            },
            headers: { "Content-Type": "application/json" }
        })
        return AdminLoginRes = res.data

    } catch (error) {
        return AdminLoginRes = error.response.data
    }
})
